module.exports = __webpack_public_path__ + "img/idCard2.17361d87.png";